import { useSocketNotificationContext } from '../context';
import { useEffect, useRef } from 'react';
import { v4 as generateUuid } from 'uuid';
export const useSocketTopicSubscription = ({ topic, recipients, onMessage }) => {
    const { subscribeTopic, unsubscribeTopic } = useSocketNotificationContext();
    const subscriberIdRef = useRef(null);
    useEffect(() => {
        if (!subscriberIdRef.current) {
            subscriberIdRef.current = generateUuid();
        }
        subscribeTopic({ topic, recipients, onMessage, subscriberId: subscriberIdRef.current });
        return () => {
            unsubscribeTopic({ topic, recipients, subscriberId: subscriberIdRef.current });
        };
    }, [onMessage]);
};
//# sourceMappingURL=useSocketTopicSubscription.js.map